import { useAtom } from "jotai";

import { pointsOfImpactOrderedListAtom } from "atoms/pointsOfImpact";

import { PointOfImpact } from "../types";

const removeFromIndex = <List>(list: List[], index: number) => [...list.slice(0, index), ...list.slice(index + 1)];

export const usePointOfImpactList = () => {
  const [selected, setSelected] = useAtom(pointsOfImpactOrderedListAtom);

  const setOrderedList = (key: PointOfImpact, value: boolean) => {
    if (!value && selected.includes(key)) {
      const selectedIndex = selected.indexOf(key);

      setSelected(removeFromIndex(selected, selectedIndex));
    } else if (!selected.includes(key)) {
      setSelected([...selected, key]);
    }
  };

  return { orderedList: selected, setOrderedList };
};
